export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";